module.exports = __webpack_public_path__ + "img/icon_instagram_loupe_moins.4b6a794e.svg";